// extracted by mini-css-extract-plugin
export var typingIndicator = "_qe-0";